import Form, { formCreate } from '@/found/components/form';
import PhotoRespVos from './photo_list.vue';

formCreate.component('PhotoRespVos', PhotoRespVos);

export default {
  name: 'table-component',
  extends: Form,
  data() {
    return {
      formFunctionCode: 'travel_promotion_list_form',
    };
  },
  components: {
    formCreate: formCreate.$form(),
  },
  methods: {
    formComplete() {
      if (this.formConfig.code === 'view') {
        const tempData = this.formConfig.row;
        this.setValue(tempData);
        if (tempData && tempData.photoRespVos && tempData.photoRespVos.length !== 0) {
          this.hiddenFields(false, ['photoRespVos', 'title1']);
        } else {
          this.hiddenFields(true, ['photoRespVos', 'title1']);
        }
      }
    },
    setRule(item) {
      const v = item;
      if (v.field === 'photoRespVos') {
        v.props.value = this.formConfig.row.photoRespVos || [];
      }
      return v;
    },

  },

};
